/* Spanial homepage interactions: reveal on scroll, arrivals tabs,
   category filter/search/drag, counters, GSAP scroll motion
   (progressively enhanced, all guarded by window.gsap). */
(function () {
  "use strict";

  var rm = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function fmt(n) {
    var s = String(n);
    if (s.length <= 3) return s;
    var last = s.slice(-3), rest = s.slice(0, -3);
    return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + last;
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".sp-rv:not([data-sp-rv-init])");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.setAttribute("data-sp-rv-init", ""); el.classList.add("sp-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("sp-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute("data-sp-rv-init", ""); io.observe(el); });
  }

  /* ---------- arrivals: tabs ---------- */
  function initArrivalTabs() {
    document.querySelectorAll("[data-sp-arrivals]:not([data-sp-init])").forEach(function (root) {
      root.setAttribute("data-sp-init", "");
      var tabs = [].slice.call(root.querySelectorAll(".sp-tab"));
      var grids = [].slice.call(root.querySelectorAll(".sp-grid"));
      tabs.forEach(function (b) {
        b.addEventListener("click", function () {
          if (b.getAttribute("aria-selected") === "true") return;
          tabs.forEach(function (x) { x.setAttribute("aria-selected", "false"); });
          b.setAttribute("aria-selected", "true");
          var target = b.getAttribute("data-tab");
          grids.forEach(function (g) {
            if (g.getAttribute("data-tab-panel") === target) {
              g.hidden = false;
              g.style.opacity = "0";
              requestAnimationFrame(function () {
                g.style.transition = "opacity .22s";
                g.style.opacity = "1";
              });
            } else {
              g.hidden = true;
            }
          });
        });
      });
    });
  }

  /* ---------- categories: chips + search + drag scroll ---------- */
  function initCategories() {
    document.querySelectorAll("[data-sp-categories]:not([data-sp-init])").forEach(function (root) {
      root.setAttribute("data-sp-init", "");
      var cats = [].slice.call(root.querySelectorAll(".sp-cat"));
      var q = root.querySelector(".sp-cat-search-input");
      var empty = root.querySelector(".sp-cat-empty");
      var group = "all";

      function apply() {
        var s = ((q && q.value) || "").trim().toLowerCase();
        var n = 0;
        cats.forEach(function (c) {
          var ok = (group === "all" || c.dataset.g === group || c.dataset.g === "all") &&
            (!s || c.dataset.k.indexOf(s) > -1);
          c.hidden = !ok;
          if (ok) n++;
        });
        if (empty) empty.style.display = n ? "none" : "block";
      }

      if (q) q.addEventListener("input", apply);

      root.querySelectorAll(".sp-chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          root.querySelectorAll(".sp-chip").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          chip.setAttribute("aria-pressed", "true");
          group = chip.dataset.f;
          apply();
        });
      });

      var sc = root.querySelector(".sp-cat-scroll");
      if (sc) {
        var down = false, sx = 0, sl = 0;
        sc.addEventListener("pointerdown", function (e) { down = true; sx = e.clientX; sl = sc.scrollLeft; });
        window.addEventListener("pointerup", function () { down = false; });
        sc.addEventListener("pointermove", function (e) { if (!down) return; sc.scrollLeft = sl - (e.clientX - sx); });
      }
    });
  }

  /* ---------- counters (gsap tween if available, else instant fill) ---------- */
  function runCounts(root) {
    if (root.hasAttribute("data-sp-counted")) return;
    root.setAttribute("data-sp-counted", "");
    root.querySelectorAll(".sp-counts > div").forEach(function (d, i) {
      setTimeout(function () { d.classList.add("sp-on"); }, i * 120);
    });
    root.querySelectorAll("[data-count]").forEach(function (el) {
      var end = +el.dataset.count, suf = el.dataset.suffix || "";
      if (rm || !window.gsap) {
        el.textContent = fmt(end) + suf;
        return;
      }
      var o = { v: 0 };
      gsap.to(o, {
        v: end, duration: 1.6, ease: "power2.out",
        onUpdate: function () { el.textContent = fmt(Math.round(o.v)) + suf; }
      });
    });
  }

  /* ---------- wait briefly for GSAP + ScrollTrigger, then decide the motion path once ---------- */
  function waitForGsap(cb, timeoutMs) {
    var start = Date.now();
    (function poll() {
      if (window.gsap && window.ScrollTrigger) { cb(true); return; }
      if (Date.now() - start > (timeoutMs || 2500)) { cb(false); return; }
      setTimeout(poll, 60);
    })();
  }

  function initHeroMotion(gsapReady) {
    document.querySelectorAll(".sp-hero:not([data-sp-motion])").forEach(function (hero) {
      hero.setAttribute("data-sp-motion", "");
      if (!gsapReady) return;
      var copy = hero.querySelector(".sp-hero-copy");
      if (copy) gsap.from(copy, { y: -16, opacity: 0, duration: 1, delay: 0.2 });
      var ks = hero.querySelectorAll(".sp-panel .sp-lab .sp-k");
      if (ks.length) gsap.from(ks, { yPercent: 60, duration: 1.1, stagger: 0.12, ease: "power4.out", delay: 0.3 });
    });
  }

  function initStoryMotion(gsapReady) {
    document.querySelectorAll("[data-sp-story]:not([data-sp-motion])").forEach(function (root) {
      root.setAttribute("data-sp-motion", "");
      var counts = root.querySelector(".sp-counts");
      var rule = root.querySelector(".sp-rule");

      if (gsapReady) {
        var lines = root.querySelectorAll(".sp-big .sp-ln span");
        if (lines.length) {
          gsap.from(lines, {
            yPercent: 110, duration: 1.1, ease: "power4.out", stagger: 0.09,
            scrollTrigger: { trigger: root, start: "top 70%" }
          });
        }
        var lead = root.querySelector(".sp-lead");
        if (lead) {
          gsap.from(lead, {
            y: 24, opacity: 0, duration: 0.9, delay: 0.3,
            scrollTrigger: { trigger: root, start: "top 70%" }
          });
        }
        if (rule) {
          gsap.to(rule, {
            scaleX: 1, duration: 1.4, ease: "power3.inOut",
            scrollTrigger: { trigger: rule, start: "top 88%" }
          });
        }
        if (counts) {
          ScrollTrigger.create({ trigger: counts, start: "top 88%", once: true, onEnter: function () { runCounts(root); } });
        }
        var mark = root.querySelector(".sp-mark");
        if (mark) {
          gsap.to(mark, {
            yPercent: -18, rotate: 18, ease: "none",
            scrollTrigger: { trigger: root, start: "top bottom", end: "bottom top", scrub: true }
          });
        }
      } else if (counts) {
        if (!("IntersectionObserver" in window)) {
          runCounts(root);
          if (rule) rule.style.transform = "scaleX(1)";
        } else {
          var cio = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              cio.unobserve(e.target);
              runCounts(root);
              if (rule) rule.style.transform = "scaleX(1)";
            });
          }, { threshold: 0.3 });
          cio.observe(counts);
        }
      }
    });
  }


  /* ---------- brand arc pattern (from the Spanial identity), optional GSAP spin ---------- */
  function initArcs(gsapReady) {
    document.querySelectorAll(".sp-arcs:not([data-sp-init])").forEach(function (el) {
      el.setAttribute("data-sp-init", "");
      var color = el.dataset.color || "#BCB534", cell = +el.dataset.cell || 140;
      var W = Math.max(el.clientWidth, 900) + cell * 2, H = Math.max(el.clientHeight, 500) + cell * 2;
      var R = cell * 0.30, sw = cell * 0.12, rowH = cell * 0.78;
      var ns = "http://www.w3.org/2000/svg", svg = document.createElementNS(ns, "svg");
      svg.setAttribute("viewBox", "0 0 " + W + " " + H); svg.setAttribute("width", W); svg.setAttribute("height", H);
      svg.setAttribute("preserveAspectRatio", "xMidYMid slice");
      var angles = [0, 90, 180, 270, 0, 90, 180, 270, 45, 135, 225, 315], seed = 7;
      function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      var rows = Math.ceil(H / rowH), cols = Math.ceil(W / cell) + 1;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var x = c * cell + (r % 2 ? cell / 2 : 0) + (rnd() - .5) * cell * .18, y = r * rowH + (rnd() - .5) * rowH * .18;
          var g = document.createElementNS(ns, "g"); g.setAttribute("transform", "translate(" + x.toFixed(1) + " " + y.toFixed(1) + ")");
          var a = document.createElementNS(ns, "g"); a.setAttribute("class", "sp-arc");
          a.setAttribute("transform", "rotate(" + angles[Math.floor(rnd() * angles.length)] + ")");
          var box = document.createElementNS(ns, "circle"); box.setAttribute("r", R + sw / 2); box.setAttribute("fill", "none");
          var path = document.createElementNS(ns, "path");
          path.setAttribute("d", "M" + (-R) + " 0 A" + R + " " + R + " 0 0 1 0 " + (-R));
          path.setAttribute("fill", "none"); path.setAttribute("stroke", color); path.setAttribute("stroke-width", sw);
          a.appendChild(box); a.appendChild(path); g.appendChild(a); svg.appendChild(g);
        }
      }
      svg.style.left = (-cell) + "px"; svg.style.top = (-cell) + "px";
      el.appendChild(svg);
      if (!gsapReady || rm) return;
      var arcs = svg.querySelectorAll(".sp-arc");
      gsap.to(arcs, {
        rotation: "+=90", duration: 1.3, ease: "power2.inOut", transformOrigin: "50% 50%",
        stagger: { each: 0.045, grid: [rows, cols], from: "random", repeat: -1, repeatDelay: 2.6 }
      });
      gsap.to(svg, { y: -cell * 0.5, duration: 18, ease: "sine.inOut", yoyo: true, repeat: -1 });
    });
  }

  function initStoreRowsMotion(gsapReady) {
    document.querySelectorAll(".sp-store-list:not([data-sp-motion])").forEach(function (list) {
      list.setAttribute("data-sp-motion", "");
      var items = list.querySelectorAll("li");
      if (!gsapReady) {
        items.forEach(function (li) { li.classList.add("sp-on"); });
        return;
      }
      items.forEach(function (li) {
        var store = li.querySelector(".sp-store");
        if (!store) return;
        gsap.from(store, {
          x: -28, opacity: 0, duration: 0.8, ease: "power3.out",
          scrollTrigger: { trigger: li, start: "top 92%", once: true, onEnter: function () { li.classList.add("sp-on"); } }
        });
      });
    });
  }

  function initIgAndPostsMotion(gsapReady) {
    if (!gsapReady) return;
    document.querySelectorAll(".sp-ig-cols:not([data-sp-motion])").forEach(function (el) {
      el.setAttribute("data-sp-motion", "");
      var items = el.querySelectorAll(".sp-ig-grid a");
      if (items.length) {
        gsap.from(items, {
          y: 20, opacity: 0, duration: 0.7, stagger: 0.06, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 85%" }
        });
      }
    });
    document.querySelectorAll(".sp-posts:not([data-sp-motion])").forEach(function (el) {
      el.setAttribute("data-sp-motion", "");
      var items = el.querySelectorAll(".sp-post");
      if (items.length) {
        gsap.from(items, {
          y: 24, opacity: 0, duration: 0.8, stagger: 0.12, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 85%" }
        });
      }
    });
  }

  function boot() {
    initReveal();
    initArrivalTabs();
    initCategories();
    waitForGsap(function (ready) {
      if (ready && window.gsap && window.gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
        /* Horizon scrolls inside .page-wrapper (html/body are overflow hidden) */
        var pw = document.querySelector('.page-wrapper');
        if (pw) {
          var ov = getComputedStyle(pw).overflowY;
          if (ov === 'auto' || ov === 'scroll') { ScrollTrigger.defaults({ scroller: pw }); }
        }
        /* safety net: never leave anything invisible if a trigger misfires */
        setTimeout(function () {
          document.querySelectorAll('.sp-ig-grid a, .sp-post, .sp-store, .sp-lead, .sp-hero-copy').forEach(function (el) {
            if (getComputedStyle(el).opacity === '0') { gsap.set(el, { opacity: 1, y: 0, x: 0, clearProps: 'transform' }); }
          });
        }, 4000);
      }
      initHeroMotion(ready);
      initArcs(ready);
      initStoryMotion(ready);
      initStoreRowsMotion(ready);
      initIgAndPostsMotion(ready);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* re-run for sections added or reloaded in the theme editor */
  document.addEventListener("shopify:section:load", function () {
    initReveal();
    initArrivalTabs();
    initCategories();
    initArcs(!!(window.gsap));
  });
})();
